import { useEffect, useState } from 'react'

/** Breakpoint for mobile-browser layout overrides (not native app WebView). */
export const MOBILE_WEB_MAX_WIDTH_PX = 768

export function isMobileWebViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(`(max-width: ${MOBILE_WEB_MAX_WIDTH_PX}px)`).matches
}

export function useMobileWebViewport(): boolean {
  const [matches, setMatches] = useState(() => isMobileWebViewport())

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_WEB_MAX_WIDTH_PX}px)`)
    const onChange = () => setMatches(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  return matches
}
